/**
 * aqua.js
 * Custom JS for Aqua theme layer
 */

// ---------------------------------------------------------------------------
// Form styles — consumed by Shopify Forms App before render via formStyles Map
// Must be set before the Forms app initialises, so this runs synchronously
// ---------------------------------------------------------------------------

// window.formStyles = window.formStyles || new Map();
// 
// window.formStyles.set('custom-heading-styles', `
//   :host {
//     --forms-body-font: var(--font-body--family);
//     --forms-heading-font: var(--font-heading--family);
//     --form-field-border-radius: var(--style-border-radius-inputs);
//     --form-field-border: #0000000D;
//     --form-background-color: #F2F1EE;
//     --button-border-radius: var(--style-border-radius-inputs);
//     --form-field-border-focused: 0 0 0 1px #1a1a1a;
//   }
// 
//   h2[class*="textHeading"] {
//     font-family: var(--font-heading--family) !important;
//     font-style: var(--font-h3--style);
//     font-weight: var(--font-h3--weight) !important;
//     font-size: var(--font-h3--size) !important;
//     line-height: var(--font-h3--line-height);
//     letter-spacing: var(--font-h3--letter-spacing);
//     text-transform: uppercase !important;
//     margin: 0 0 16px 0 !important;
//   }
// 
//   [class*="formDisclaimer"],
//   [class*="textBody"] p {
//     font-style: var(--font-paragraph--style) !important;
//     font-weight: var(--font-paragraph--weight) !important;
//     font-size: var(--font-paragraph--size) !important;
//     line-height: var(--font-paragraph--line-height) !important;
//     text-transform: var(--font-paragraph--case) !important;
//     -webkit-font-smoothing: antialiased !important;
//   }
// 
//   [class*="formDisclaimer"] {
//     color: #17171766 !important;
//   }
// 
//   .phone-country-selector {
//     background-color: #F2F1EE !important;
//   }
// 
//   label {
//     text-transform: uppercase;
//   }
//   textarea + label {
//     text-transform: unset;
//   }
// 
//   input,
//   textarea,
//   select {
//     font-size: var(--font-paragraph--size);
//   }
// 
//   [class*="selectToggle"] {
//     max-height: unset !important;
//   }
// 
//   [class*="selectContainer"] {
//     display: flex;
//     align-items: center;
//     font: var(--forms-body-font);
//     background-color: var(--form-background-color);
//     color: var(--form-text-color);
//     box-shadow: var(--form-field-border);
//     padding-left: var(--form-field-padding);
//   }
// 
//   [class*="selectContainer"] [class*="_textBody"] {
//     font-size: var(--font-paragraph--size);
//     text-transform: uppercase;
//     padding: 0;
//   }
// 
//   [class*="formFieldContainer"] [class*="formInputFieldLabel"] {
//     top: var(--input-label-top) !important;
//   }
// 
//   button {
//     font-size: calc(var(--font-size--paragraph) * 0.79) !important;
//     text-transform: uppercase !important;
//   }
// `);


// ---------------------------------------------------------------------------
// Slideshow + PDP fixes
// ---------------------------------------------------------------------------
(function () {

  function getPageType() {
    return window.ShopifyAnalytics?.meta?.page?.pageType;
  }

  // ---- Card gallery reset (Safari fix) ------------------------------------

  function resetSlideshow(slideshow) {
    const isDisabled = slideshow.getAttribute('disabled') === 'true';
    const scroller = slideshow.querySelector('slideshow-slides');
    if (!scroller) return;

    if (isDisabled) {
      scroller.scrollLeft = 0;
      const slides = [...slideshow.querySelectorAll('slideshow-slide')].filter(s => !s.hasAttribute('hidden'));
      slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
      });
    } else {
      if (typeof slideshow.select === 'function') {
        const slides = [...slideshow.querySelectorAll('slideshow-slide')].filter(s => !s.hasAttribute('hidden'));
        const slideId = slides[0]?.getAttribute('slide-id');
        if (slideId) {
          try {
            slideshow.select({ id: slideId }, undefined, { animate: false });
          } catch (e) {}
        }
      }
    }
  }

  function resetAllCardGalleries() {
    document.querySelectorAll('.card-gallery slideshow-component')
      .forEach(resetSlideshow);
  }

  function scheduleReset() {
    resetAllCardGalleries();
    setTimeout(resetAllCardGalleries, 50);
    setTimeout(resetAllCardGalleries, 200);
    setTimeout(resetAllCardGalleries, 500);
  }

  function observeCardGalleries() {
    const mo = new MutationObserver((mutations) => {
      const toReset = new Set();

      for (const mutation of mutations) {
        const target = /** @type {Element} */ (mutation.target);

        if (mutation.attributeName === 'in-viewport' && target.closest('.card-gallery')) {
          toReset.add(target.closest('slideshow-component'));
        }

        if (mutation.attributeName === 'aria-hidden') {
          const slideshow = target.closest('.card-gallery slideshow-component');
          if (slideshow && slideshow.getAttribute('disabled') === 'true') {
            toReset.add(slideshow);
          }
        }
      }

      if (toReset.size === 0) return;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          toReset.forEach(sw => sw && resetSlideshow(sw));
        });
      });
    });

    mo.observe(document.body, {
      attributes: true,
      attributeFilter: ['in-viewport', 'aria-hidden'],
      subtree: true,
    });
  }

  // ---- PDP carousel arrows ------------------------------------------------

  function initPDPCarouselArrows() {
    const gallery = document.querySelector('.media-gallery--carousel');
    if (!gallery) return;
    const slideshow = gallery.querySelector('slideshow-component');
    if (!slideshow) return;

    function waitForInit() {
      if (typeof slideshow.select !== 'function' || !slideshow.slides?.length) {
        setTimeout(waitForInit, 50);
        return;
      }

      const scroller = slideshow.querySelector('slideshow-slides');

      Object.defineProperty(slideshow, 'nextIndex', {
        get() { return this.current + 1; },
        configurable: true,
      });
      Object.defineProperty(slideshow, 'previousIndex', {
        get() { return this.current - 1; },
        configurable: true,
      });

      function scrollToSlide(slide, animate) {
        if (!scroller || !slide) return;
        scroller.scrollTo({ left: slide.offsetLeft, behavior: animate ? 'smooth' : 'instant' });
      }

      slideshow.next = function (event, options) {
        event?.preventDefault();
        const slides = this.slides;
        if (!slides?.length) return;
        const target = this.current + 1;
        const animate = options?.animate !== false;
        if (target >= slides.length) {
          scrollToSlide(slides[slides.length - 1], false);
          requestAnimationFrame(() => scrollToSlide(slides[0], animate));
          return;
        }
        if (scroller) scroller.style.scrollSnapType = 'none';
        this.select(target, event, options);
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (scroller) scroller.style.scrollSnapType = '';
        }));
      };

      slideshow.previous = function (event, options) {
        event?.preventDefault();
        const slides = this.slides;
        if (!slides?.length) return;
        const target = this.current - 1;
        const animate = options?.animate !== false;
        if (target < 0) {
          scrollToSlide(slides[0], false);
          requestAnimationFrame(() => scrollToSlide(slides[slides.length - 1], animate));
          return;
        }
        if (scroller) scroller.style.scrollSnapType = 'none';
        this.select(target, event, options);
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (scroller) scroller.style.scrollSnapType = '';
        }));
      };
    }

    waitForInit();
  }

  // ---- Init ---------------------------------------------------------------

  document.addEventListener('DOMContentLoaded', () => {
    const pageType = getPageType();
    if (pageType === 'product') {
      initPDPCarouselArrows();
    }
    scheduleReset();
    observeCardGalleries();
  });

  window.addEventListener('pageshow', (e) => {
    if (e.persisted) scheduleReset();
  });

  document.addEventListener('shopify:section:load', scheduleReset);

})();